<template>
    <dashboard-criticality-card
        title="65 Yaşı Geçen Sürücüler"
        :fields="fields"
        :provider="provider"
        :get-level="getLevel"
        :stats-config="statsConfig"
        :sort-value="sortValue"
        :enabled-levels="enabledLevels"
        excel-file-name="65_Yas_Ustu_Suruculer" />
</template>

<script>
import EmployeeOperationsApi from "@/api/employee-operations";
import DashboardCriticalityCard from "./DashboardCriticalityCard.vue";

export default {
    components: { DashboardCriticalityCard },
    props: {
        enabledLevels: { type: Array, default: null },
    },
    data() {
        return {
            fields: [
                { name: "Personel", key: "EmployeeFullName" },
                { name: "Sicil No", key: "RegistrationCode" },
                { name: "İşe Başlama Tarihi", key: "JobStartDate" },
                { name: "Yaş", key: "Age" },
            ],
            statsConfig: [
                { key: "danger", label: "65 Yaş Üstü", variant: "danger" },
                { key: "warning", label: "60-65 Arası", variant: "warning" },
            ],
        };
    },
    methods: {
        provider() {
            return EmployeeOperationsApi.GetOver65Years();
        },
        getLevel(r) {
            if (r?.Age > 65) return "danger";
            if (r?.Age >= 60) return "warning";
            return null;
        },
        sortValue(r) {
            const n = Number(r?.Age);
            return Number.isFinite(n) ? -n : Number.POSITIVE_INFINITY;
        },
    },
};
</script>
